import { useEffect, useState } from "react";
import { defaultPrimitive, ILandingPrimitive } from "../data/interfaces";

/* Protopia Ecosystem component */
export interface IusePrimitiveDataProps {
   
}
const usePrimitiveData = (primitiveData: ILandingPrimitive | string | undefined ): ILandingPrimitive => {
   const [ primitive, setPrimitive ] = useState<ILandingPrimitive>(!primitiveData || typeof primitiveData === "string"
        ?
        {
            ...defaultPrimitive(),
            data: {id:"PRIMITIVE DATA STRING"}
        } as ILandingPrimitive
        :
        primitiveData)

    useEffect(() => {
        setPrimitive(
            !primitiveData || typeof primitiveData === "string"
                ?
                {
                    ...defaultPrimitive(),
                    data: {id:"PRIMITIVE DATA STRING"}
                } as ILandingPrimitive
                :
                primitiveData
        )
    }, [primitiveData])
    return primitive
}
export default usePrimitiveData